import { CapabilityApplications } from '@hcs/types';

const LOCAL_STORAGE_PRICING_DONT_SHOW_AGAIN = 'org-pricing-dont-show-again';

export const getLocalStorageDontShowAgain = (
  applicationKey: CapabilityApplications,
) => {
  return localStorage.getItem(
    `${LOCAL_STORAGE_PRICING_DONT_SHOW_AGAIN}-${applicationKey}`,
  );
};

export const setLocalStorageDontShowAgain = (
  applicationKey: CapabilityApplications,
  dontShowAgain: boolean,
) => {
  localStorage.setItem(
    `${LOCAL_STORAGE_PRICING_DONT_SHOW_AGAIN}-${applicationKey}`,
    dontShowAgain.toString(),
  );
};
